import Blue from '~/core';
import { CountUp } from 'countup.js';

// global error messages
let errorMsg = {
	'debt': '',
	'nan': '',
	'min': '',
	'max': '',
}
new Blue({
	name: 'calc tabs',
	selector: '.calc',
	setup(calc) {
		const tabs = calc.querySelectorAll('.calc__tab');
		const contents = calc.querySelectorAll('.calc__content');
		const descriptions = calc.querySelectorAll('.calc__header-description');
		// grabbing error messages from data attributes here for convenience
		errorMsg.debt = calc.dataset.errorDebt
		errorMsg.nan = calc.dataset.errorNan
		errorMsg.min = calc.dataset.errorMin
		errorMsg.max = calc.dataset.errorMax

		const select = function() {
			let idx = Array.prototype.indexOf.call(tabs, this);

			clearError(calc);

			tabs.forEach(t => t.classList.remove('active'));
			contents.forEach(c => c.classList.remove('active'));
			descriptions.forEach(d => d.classList.remove('active'));

			this.classList.add('active');
			contents[idx].classList.add('active');
			descriptions[idx].classList.add('active');
		};

		tabs.forEach(t => this.$addEvents(t, 'click enter', select));
	},
});

new Blue({
	name: 'calc budget math',
	selector: '.calc #budget',
	setup(calc) {
		const calc__btn = calc.querySelector('#pur__calculate');
		const reset__btn = calc.querySelector('#pur__reset');

		const val__income = calc.querySelector('#pur__income');
		const val__debt = calc.querySelector('#pur__debt');
		const val__down = calc.querySelector('#pur__down');
		const val__interest = calc.querySelector('#pur__interest');
		const val__term = calc.querySelector('#pur__term');
		
		const currencyInputs = [val__income, val__debt, val__down];
		const inputs = [val__income, val__debt, val__down, val__interest, val__term];
		
		const res__budget = calc.querySelector('#pur__budget');
		const res__loan_amount = calc.querySelector('#pur__loan_amount');
		const res__down_percent = calc.querySelector('#pur__down_percent');
		const res__loan_percent = calc.querySelector('#pur__loan_percent');
		const res__monthly_payment = calc.querySelector('#pur__monthly_payment');
		const res__principle = calc.querySelector('#pur__principle');
		const res__tax = calc.querySelector('#pur__tax');
		const res__mortgage_insurance = calc.querySelector('#pur__mortgage_insurance');

		const outputs = [
			res__budget,
			res__loan_amount,
			res__down_percent,
			res__loan_percent,
			res__monthly_payment,
			res__principle,
			res__tax,
			res__mortgage_insurance,
		];

		currencyInputs.forEach(input => {
			formatCurrency(input);
			this.$addEvents(input, "keyup", () => {
				formatCurrency(input);
			})
		});

		const do_calc = () => {
			if (!validate(inputs)) {
				return false;
			}

			let annualIncome = parseInt(deFormatCurrency(val__income.value));
			let monthlyDebt = parseInt(deFormatCurrency(val__debt.value));
			let downPayment = parseInt(deFormatCurrency(val__down.value));
			let interestRate = parseFloat(val__interest.value);
			let loanLength = parseInt(val__term.value);

			let frontEndRate = 0.29;
			let backEndRate = 0.41;
			let monthlyIncome = annualIncome / 12;
			let frontEndPITI = monthlyIncome * frontEndRate;
			let backEndPITI = monthlyIncome * backEndRate - monthlyDebt;
			let PITI = frontEndPITI < backEndPITI ? (PITI = frontEndPITI) : (PITI = backEndPITI);
			let rateConstant = interestRate / 1200;
			let amv = (1 - Math.pow(1 + rateConstant, -loanLength * 12)) / rateConstant;
			let PITIov = 1.5;
			let houseValue = 1000;
			let loanAmount;
			let ti;
			for (let i = 0; i < 20; i++) {
				ti = (PITIov / 1200) * houseValue;
				loanAmount = (PITI - ti) * amv;
				houseValue = loanAmount + downPayment;
			}
			let downPercent = (downPayment / houseValue) * 100;
			let loanToValue = ((houseValue - downPayment) / houseValue) * 100;
			let moPropTaxIns = (houseValue * PITIov) / 1200;
			let moPMI;
			if (loanToValue <= 80) {
				moPMI = 0;
			} else {
				let pmi = 0.5;
				if (loanToValue >= 85) {
					pmi = 0.5;
				}
				if (loanToValue >= 90) {
					pmi = 0.5;
				}
				if (loanToValue >= 95) {
					pmi = 0.5;
				}
				PITIov += pmi;
				houseValue = 1000;
				for (let i = 0; i < 20; i++) {
					ti = (PITIov / 1200) * houseValue;
					loanAmount = (PITI - ti) * amv;
					houseValue = loanAmount + downPayment;
				}
				downPercent = (downPayment / houseValue) * 100;
				moPropTaxIns = (houseValue * (PITIov - 0.5)) / 1200;
				moPMI = (houseValue * pmi) / 1200;
				loanToValue = ((houseValue - downPayment) / houseValue) * 100;
			}
			let moPrincipalInterest = loanAmount / amv;
			let totalMonthly = moPrincipalInterest + moPropTaxIns + moPMI;

			if (loanAmount <= 0 || houseValue <= 0) {
				setError(calc, errorMsg.debt);
				return false;
			}

			const results = [
				[res__budget, houseValue, { prefix: '$', suffix: '' , decimal: 0}],
				[res__loan_amount, loanAmount, { prefix: '$', suffix: '' , decimal: 0}],
				[res__down_percent, downPercent, { prefix: '', suffix: '%' , decimal: 2}],
				[res__loan_percent, loanToValue, { prefix: '', suffix: '%' , decimal: 2}],
				[res__monthly_payment, totalMonthly, { prefix: '$', suffix: '' , decimal: 2}],
				[res__principle, moPrincipalInterest, { prefix: '$', suffix: '' , decimal: 2}],
				[res__tax, moPropTaxIns, { prefix: '$', suffix: '' , decimal: 2}],
				[res__mortgage_insurance, moPMI, { prefix: '$', suffix: '' , decimal: 2}],
			];

			results.forEach(result => {
				const el = result[0];
				const data = result[1];
				const opts = { duration: 1.5 };
				const { prefix, suffix, decimal } = result[2];
				opts.prefix = prefix;
				opts.suffix = suffix;
				opts.decimalPlaces = decimal;
				const counter = new CountUp(el, data, opts);
				if (!counter.error) {
					counter.start();
				} else {
					console.error(counter.error);
				}
			});
		};

		const do_reset = () => {
			clearError(calc);
			inputs.forEach(i => (i.value = i.dataset.orig));
			outputs.forEach(o => (o.textContent = ''));
		};

		const init = () => {
			inputs.forEach(
				i => (
					(i.dataset.orig = i.value),
					this.$addEvents(i, 'enter.stop.prevent', do_calc),
					this.$addEvents(i, 'input', () => clearError(calc))
				)
			);
			this.$addEvents(calc__btn, 'click.prevent enter.prevent', do_calc);
			this.$addEvents(reset__btn, 'click.prevent enter.prevent', do_reset);
		};

		init();
	},
});

new Blue({
	name: 'calc payment math',
	selector: '.calc #payments',
	setup(calc) {
		const calc__btn = calc.querySelector('#pay__calculate');
		const reset__btn = calc.querySelector('#pay__reset');

		const val__amount = calc.querySelector('#pay__amount');
		const val__term = calc.querySelector('#pay__term');
		const val__interest = calc.querySelector('#pay__interest');

		const inputs = [val__amount, val__term, val__interest];

		const res__principle = calc.querySelector('#pay__principle');
		const res__tax = calc.querySelector('#pay__tax');
		const res__insurance = calc.querySelector('#pay__insurance');
		const res__total = calc.querySelector('#pay__total');

		const outputs = [res__principle, res__tax, res__insurance, res__total];

		formatCurrency(val__amount);
		this.$addEvents(val__amount, "keyup", () => {
			formatCurrency(val__amount);
		});

		const do_calc = () => {
			if (!validate(inputs)) {
				return false;
			}

			let loanAmount = parseInt(deFormatCurrency(val__amount.value));
			let loanLength = parseInt(val__term.value);
			let interestRate = parseFloat(val__interest.value);

			let monthlyInterest = interestRate / 1200;
			let annualTaxes = loanAmount * 0.01;
			let annualInterest = loanAmount * 0.005;
			let base = 1;
			let mBase = 1 + monthlyInterest;
			for (let i = 0; i < loanLength * 12; i++) {
				base = base * mBase;
			}
			let principalInterest = (loanAmount * monthlyInterest) / (1 - 1 / base);
			let monthlyTaxes = annualTaxes / 12;
			let monthlyPayment;

			monthlyInterest = annualInterest / 12;
			monthlyPayment = principalInterest + monthlyTaxes + monthlyInterest;

			const results = [
				[res__principle, principalInterest, { prefix: '$', suffix: '', decimal: 2 }],
				[res__tax, monthlyTaxes, { prefix: '$', suffix: '', decimal: 2 }],
				[res__insurance, monthlyInterest, { prefix: '$', suffix: '', decimal: 2 }],
				[res__total, monthlyPayment, { prefix: '$', suffix: '', decimal: 2 }],
			];

			results.forEach(result => {
				const el = result[0];
				const data = result[1];
				const opts = { duration: 1.5 };
				const { prefix, suffix, decimal } = result[2];
				opts.prefix = prefix;
				opts.suffix = suffix;
				opts.decimalPlaces = decimal;
				const counter = new CountUp(el, data, opts);
				if (!counter.error) {
					counter.start();
				} else {
					console.error(counter.error);
				}
			});
		};

		const do_reset = () => {
			clearError(calc);
			inputs.forEach(i => (i.value = i.dataset.orig));
			outputs.forEach(o => (o.textContent = ''));
		};

		const init = () => {
			inputs.forEach(
				i => (
					(i.dataset.orig = i.value),
					this.$addEvents(i, 'enter.stop.prevent', do_calc),
					this.$addEvents(i, 'input', () => clearError(calc))
				)
			);
			this.$addEvents(calc__btn, 'click.prevent enter.prevent', do_calc);
			this.$addEvents(reset__btn, 'click.prevent enter.prevent', do_reset);
		};

		init();
	},
});

function formatCurrency(input) {
	let val = deFormatCurrency(input.value);
	let arr = val.split("");
	if (arr.length > 3) {
		let div = Math.floor(arr.length / 3);
		if (arr.length % 3 === 0) div--;
		for (div; div > 0; div--) {
			arr.splice(-3 * div, 0, ",");
		}
	}
	input.value = '$' + arr.join("");
}

function deFormatCurrency(string) {
	let arr = string.split("");
	let num = ["0","1","2","3","4","5","6","7","8","9"];
	return arr.filter(n => num.includes(n)).join("");
}

function setError(calc, msg) {
	const calc__error = calc.closest('.calc').querySelector('.calc__error');
	calc__error.textContent = msg;
}

function clearError(calc) {
	const calc__error = calc.closest('.calc').querySelector('.calc__error');
	calc__error.textContent = '';
}

function validate(inputs) {
	return inputs.every(input => {
		const value = (input.matches("input[type=text]")) ? parseFloat(deFormatCurrency(input.value)) : parseFloat(input.value);
		const name = input.previousElementSibling.textContent.trim();
		const regex = new RegExp(/\d/, 'gmi');
		const min = input.hasAttribute('min') ? parseFloat(input.getAttribute('min')) : false;
		const max = input.hasAttribute('max') ? parseFloat(input.getAttribute('max')) : false;

		if (value === NaN || !regex.test(value)) {
			// setError(input, `'${name}' must be a number.`);
			let re = /\[Field Name\]/
			let error = errorMsg.nan.replace(re, name)
			setError(input, error);
			return false;
		}

		if (min && value < min) {
			// setError(input, `'${name}' must be greater than ${min}.`);
			let re = /\[Field Name\]/
			let re2 = /\[Min Value\]/
			let error = errorMsg.min.replace(re, name).replace(re2, min)
			setError(input, error)
			return false;
		}

		if (max && value > max) {
			// setError(input, `'${name}' must be less than ${max}.`);
			let re = /\[Field Name\]/
			let re2 = /\[Max Value\]/
			let error = errorMsg.max.replace(re, name).replace(re2, max)
			setError(input, error)
			return false;
		}

		return true;
	});
}